export default __webpack_public_path__ + "static/media/match-blue.fb671a08.svg";